import { Pressable, PressableProps } from '../pressable';

import { useCheckbox } from './context';

export type CheckboxPressableProps = Omit<
  PressableProps,
  'role' | 'aria-checked' | 'aria-label' | 'onPress' | 'disabled' | 'softDisabled'
>;

export function CheckboxPressable(props: CheckboxPressableProps) {
  const checkbox = useCheckbox();

  const accessibilityLabel = checkbox.unavailable
    ? `${checkbox.label}. Unavailable`
    : checkbox.label;

  return (
    <Pressable
      ref={checkbox.pressableRef}
      role="checkbox"
      aria-checked={checkbox.checked}
      disabled={checkbox.disabled || checkbox.unavailable}
      softDisabled={checkbox.softDisabled}
      onPress={checkbox.handlePress}
      accessibilityLabel={accessibilityLabel}
      aria-label={accessibilityLabel}
      {...props}
    />
  );
}
